import StripeConfig from './views/stripe.config';

export default{
  views: { StripeConfig, },
};
